import JSZip from 'jszip';
import { saveAs } from 'file-saver';

export const downloadFileWithBlob = (csvData: string, fileName: string) => {
    try {
        const blob = new Blob([csvData], { type: 'text/csv' });
        const downloadUrl = window.URL.createObjectURL(blob);

        // 创建一个隐藏的 <a> 元素
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = downloadUrl;
        a.download = fileName;

        // 将 <a> 元素添加到文档中并触发点击事件以启动下载
        document.body.appendChild(a);
        a.click();

        // 清理
        window.URL.revokeObjectURL(downloadUrl);
        document.body.removeChild(a);
    } catch (e) {
        console.error(e);
    }
};

export const downloadZipWithBlob = (zipData: string, fileName: string) => {
    try {
        const blob = new Blob([zipData], { type: 'application/zip' });
        const downloadUrl = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = downloadUrl;
        a.download = fileName;

        document.body.appendChild(a);
        a.click();

        window.URL.revokeObjectURL(downloadUrl);
        document.body.removeChild(a);
    } catch (e) {
        console.error(e);
    }
};

const loadImage = (url: string) => {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = 'anonymous'; // 设置为 "anonymous" 启用跨域支持

        img.onload = () => resolve(img);
        img.onerror = reject;
        img.src = url;
    });
};

const downloadImageAndAddToZip = async (zip: JSZip, url: string, filename: string) => {
    try {
        const img: any = await loadImage(url);

        // 创建一个 canvas 元素，将图片绘制到 canvas 上
        const canvas = document.createElement('canvas');
        canvas.width = img?.width;
        canvas.height = img?.height;
        const ctx = canvas.getContext('2d')!;
        ctx.drawImage(img, 0, 0);

        // 将 canvas 数据添加到 zip 文件
        const imageDataUrl = canvas.toDataURL('image/png');
        const binaryData = atob(imageDataUrl.split(',')[1]);
        const dataArray = new Uint8Array(binaryData.length);
        for (let i = 0; i < binaryData.length; i++) {
            dataArray[i] = binaryData.charCodeAt(i);
        }

        zip.file(filename, dataArray, { binary: true });
    } catch (error) {
        console.error('Error downloading image:', error);
    }
};

export const handleDownloadPhoto = async (urls: string[], zipFileName: string) => {
    const zip = new JSZip();
    const zipFilename = `${zipFileName}.zip`;
    let count = 0;
    try {
        urls.filter((e) => !!e).forEach(async (url, index) => {
            const filename = `file-${index}.jpg`;
            await downloadImageAndAddToZip(zip, url, filename);
            count++;
            if (count === urls.length) {
                const zipFile = await zip.generateAsync({ type: 'blob' });
                saveAs(zipFile, zipFilename);
            }
        });
    } catch (ex) {
        console.error(ex);
    }
};
